import React from 'react';
import ModuleWrap from "../ModuleWrap/ModuleWrap";

const Transport = (props) => {
    return (
        <ModuleWrap title="Transport" icon={props.icon}>
                Palety dostarczamy własnym transportem pod wskazany przez klienta adres. Termin realizacji zamówień ustalamy indywidualnie.
        </ModuleWrap>
    )
};

export default Transport;


// WEBPACK FOOTER //
// ./src/components/Transport/Transport.js